import {
  Box,
  Button,
  Center,
  Flex,
  Loader,
  Paper,
  Table,
  Text,
  Title,
  createStyles,
} from "@mantine/core";
import { formatDateTime } from "@medplum/core";
import { useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  filterByValueString,
  getAccessToken,
  pushToEpicHandler,
} from "../../../utils";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/types/appState";
import { showNotification } from "@mantine/notifications";
import fetchResourceIcon from "../../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../../assets/img/storingDBLogo.svg";
import GenericInfoModal from "../../../components/GenericInfoModal";
import { IAccumulator } from "../../Appointment/AppointmentModal";
import { useDispatch } from "react-redux";
// import { findEpicPractitionerExtension } from "./Service";

const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
}));

export const Condition = () => {
  const { patientId } = useParams();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const medplum = useMedplum();
  const profile = medplum.getProfile();
  // const clientId = findEpicPractitionerExtension(profile);

  const [epicId, setEpicId] = useState<any>("");
  // const [clientId,setClientId]=useState<any>()
  const [conditions, setConditions] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [showInfoModal, setShowModal] = useState(false);
  const [succesMessage, setSuccessMessage] = useState("Storing in EPIC EHR");
  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    details: [] as any,
    confirmText: "",
    onClose: () => {},
    onConfirm: () => {},
  });
  const tableHeaders = [
    "Condition Name",
    "Recorded Date",
    "Onset Date",
    "Abatement Date",
  ];
  const modalSteps = [
    {
      loadText: "Creating Conditions in EPIC EHR",

      label: "Creating Conditions in EPIC EHR",

      icon: fetchResourceIcon,
    },
    {
      loadText: "Condition created successfully",
      label: "Condition created successfully",
      icon: fetchResourceIcon,
    },
    {
      loadText: succesMessage,
      label: succesMessage,
      icon: dbStoringIcon,
    },
  ];
  const logginedUser = useSelector((state: AppState) => state) as any;

  const epicDataFromExtension = filterByValueString(
    logginedUser?.app?.profile?.extension || ([] as any),
    "epic"
  );

  useEffect(() => {
    //  medplum.searchResources(
    //     "ClientApplication",
    //     "&name=EPIC Patient - Stage"
    //   ).then((res)=>{
    //     setClientId(res[0]?.id);
    //   })
    getCondtions();
    getPatientDetails().then((response: any) => {
      const fhirStu3Value = response[0]?.identifier?.find(
        (identifier: any) => identifier?.type?.text === "FHIR STU3"
      )?.value;
      setEpicId(fhirStu3Value);
      // updatePayloadForEpic()
    });
  }, [patientId]);
  //  const epicClientId =
  //    epicDataFromExtension[epicDataFromExtension.length - 1]?.url?.split(
  //      "/"
  //    )?.[1];
  const clientId =
    epicDataFromExtension[epicDataFromExtension?.length - 1]?.url?.split(
      "/"
    )?.[1];
  const payload = {
    request: "createResource",
    patientId: patientId,
    clientId: clientId,
    requestParams: { resourceType: "Condition", resource: conditions[0] },
    oauthData: {
      accessToken:
        epicDataFromExtension[epicDataFromExtension?.length - 1]?.extension?.[0]
          ?.valueString || "",
    },
  };

  const pushConditionsToEpic = () => {
    if (!epicId) {
      showNotification({
        color: "red",
        message: `Select Epic Patient`,
        autoClose: true,
      });
      return;
    } else {
      updatePayloadForEpic();
      const activeLogin = getAccessToken();

      try {
        const result: IAccumulator = epicDataFromExtension[
          epicDataFromExtension?.length - 1
        ]?.extension?.reduce((acc: IAccumulator, { url, valueString }) => {
          if (url === "refresh_token") {
            acc.refreshToken = valueString;
          } else if (url === "integrationType") {
            acc.integrationType = valueString;
          } else if (url === "display") {
            acc.name = valueString;
          }
          return acc;
        }, {});

        const metaData = {
          dispatch,
          clientId: clientId,
          integrationType: result.integrationType,
          refreshToken: result.refreshToken,
          activeLogin,
          name: result.name,
        };
        setShowModal(true);
        setModalData({
          title: " Please wait, we are creating Condition Resource in EPIC EHR",
          sideTitle: "",
          details: [
            { label: "Title", text: "" },
            { label: "Description", text: "" },
          ],
          confirmText: "Proceed",
          onClose: () => {
            setShowModal(false);
          },
          onConfirm: async () => {
            await pushToEpicHandler(medplum, payload, metaData).then((res) => {
              if (res) {
                if(res?.body?.error?.includes('duplicate')){
                   showNotification({
                     color: "red",
                     message: "Record already exists in Epic",
                     autoClose: true,
                   });

                }
                if(res?.status===201){
                    showNotification({
                      color: "green",
                      message: "Record successfully pushed to Epic",
                      autoClose: true,
                    });
                }
                

              } else {
                setSuccessMessage("Failed ,Please try again");
                showNotification({
                  color: "red",
                  message: "Please try again",
                  autoClose: true,
                });
              }
            });
          },
        });
      } catch (error) {
        console.log(error);
        showNotification({
          color: "red",
          message: `Failed ${error} `,
          autoClose: true,
        });
      }
    }
  };
  const getPatientDetails = () => {
    const response = medplum.searchResources("Patient", {
      _id: patientId,
    });
    return response;
  };

  const getCondtions = async () => {
    const res = await medplum.searchResources(
      "Condition",
      `patient=Patient/${patientId}`
    );
    setConditions(res);
    setIsFetching(false);
  };
 const updatePayloadForEpic = () => {
   // Update the subject reference
   conditions[0].subject.reference = `Patient/${epicId}`;

   // Delete meta and id fields if they exist
   delete conditions[0]?.meta;
   delete conditions[0]?.id;

   // Update verification status
   conditions[0].verificationStatus = {
     coding: [
       {
         system: "http://terminology.hl7.org/CodeSystem/condition-ver-status",
         version: "4.0.0",
         code: "provisional", // Update to provisional
         display: "Provisional", // Update display to provisional
       },
     ],
     text: "Provisional",
   };

   // Function to generate a random date within a specified range
   const getRandomDate = (start:any, end:any) => {
     const date = new Date(
       start.getTime() + Math.random() * (end.getTime() - start.getTime())
     );
     return date;
   };

   // Define a range for random date generation (for example: last 10 years)
   const tenYearsBack = new Date();
   tenYearsBack.setFullYear(tenYearsBack.getFullYear() - 10);
   const now = new Date();

   // Generate a random date for onsetDateTime
   const randomOnsetDate = getRandomDate(tenYearsBack, now);

   // Generate random time for onsetDateTime
   randomOnsetDate.setHours(
     Math.floor(Math.random() * 24),
     Math.floor(Math.random() * 60),
     Math.floor(Math.random() * 60)
   );

   // Update the onsetDateTime
   conditions[0].onsetDateTime = randomOnsetDate.toISOString();

   // Generate a random date for recordedDate
   const randomRecordedDate = getRandomDate(tenYearsBack, now);

   // Generate random time for recordedDate
   randomRecordedDate.setHours(
     Math.floor(Math.random() * 24),
     Math.floor(Math.random() * 60),
     Math.floor(Math.random() * 60)
   );

   // Update the recordedDate
   conditions[0].recordedDate = randomRecordedDate.toISOString();
 };

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {" "}
          <Title>Conditions</Title>
          <Button disabled={!conditions[0]} onClick={pushConditionsToEpic}>
            Push To Epic
          </Button>
        </Box>

        <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              {tableHeaders.map((val) => {
                return <th key={val}>{val}</th>;
              })}
            </tr>
          </thead>
          {
            <tbody>
              {conditions.map((data: any) => (
                <tr key={data.id}>
                  <td>{data.code.text}</td>
                  <td>{formatDateTime(data.recordedDate as string)}</td>
                  <td>{formatDateTime(data.onsetDateTime as string)}</td>
                  <td>{formatDateTime(data.abatementDateTime as string)}</td>
                </tr>
              ))}
            </tbody>
          }
        </Table>
        {conditions?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
      {showInfoModal && (
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowModal}
          showStepsImmediately={true}
          autoConfirm={true}
        />
      )}
    </>
  );
};
